var _circle, _circle2, _circle3, _circle4, _circle5, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 250,
    viewBox: "0 0 251 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 125,
    r: 125,
    fill: "url(#paint0_linear_2091_1496)",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 125,
    r: 105,
    fill: "url(#paint1_linear_2091_1496)",
    fillOpacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 125,
    r: 85,
    fill: "url(#paint2_linear_2091_1496)",
    fillOpacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 125,
    r: 65,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 125,
    r: 65,
    fill: "url(#paint3_radial_2091_1496)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.5 113.667H142.25V107.19C142.25 98.2533 134.97 91 126 91C117.03 91 109.75 98.2533 109.75 107.19V113.667H106.5C102.925 113.667 100 116.581 100 120.143V152.524C100 156.086 102.925 159 106.5 159H145.5C149.075 159 152 156.086 152 152.524V120.143C152 116.581 149.075 113.667 145.5 113.667ZM126 142.81C122.425 142.81 119.5 139.895 119.5 136.333C119.5 132.771 122.425 129.857 126 129.857C129.575 129.857 132.5 132.771 132.5 136.333C132.5 139.895 129.575 142.81 126 142.81ZM136.075 113.667H115.925V107.19C115.925 101.653 120.442 97.1524 126 97.1524C131.558 97.1524 136.075 101.653 136.075 107.19V113.667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2091_1496",
    x1: 125.5,
    y1: 0,
    x2: 125.5,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1976D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2091_1496",
    x1: 125.5,
    y1: 20,
    x2: 125.5,
    y2: 230,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#1976D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2091_1496",
    x1: 125.5,
    y1: 40,
    x2: 125.5,
    y2: 210,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#1976D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2091_1496",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.5 125) rotate(90) scale(65)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1976D2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2af1e8abf72019a39e82715062fbd582.svg";
export { ForwardRef as ReactComponent };